import { useQuery } from '@tanstack/react-query';
import { getAxios } from '../../../../lib/axios';
import { CrmEndpoints } from '../../../../constants/endpoints/crmEndpoints';
import { CompanyApprovalConfigurationModel } from '../types/approvalConfigTypes';

export function useCompanyApprovalConfigQuery(companyId: number | undefined) {
  return useQuery({
    queryKey: ['companyApprovalConfig', companyId],
    enabled: !!companyId,
    queryFn: async () =>
      (await getAxios().get<CompanyApprovalConfigurationModel>(CrmEndpoints.CompanyCrm.Approvals.get(companyId!))).data
  });
}
